import { AutogenModelWebUsers, AutogenRowWebUsers } from "./autogen/AutogenModelWebUsers";

export class ModelWebUsers extends AutogenModelWebUsers<RowWebUsers> {
	constructor() {
		super(RowWebUsers);
	}
}

export class RowWebUsers extends AutogenRowWebUsers {
}